import React from 'react'
import OperacionesVolcadoras from '../containers/OperacionesVolcadoras'

export const COLUMNS_VOLCADORAS_CON_CEREAL_ASIGNADO = [
  {
    name: 'claveVolcadora',
    label: 'Nombre',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'claveVolcadora',
    label: 'Operaciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: value => {
        return <OperacionesVolcadoras volcadora={value} />
      }
    }
  }

]
export const COLUMNS_VOLCADORAS_CON_CEREAL_ASIGNADO_TO_PRINT = [
  {
    name: 'volcadora',
    label: 'Plataforma Volcadora',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'silo',
    label: 'Silo',
    width: 60,
    mantenerCase: true
  }
]
